(function() {
  var COUPON = 'PIX5';
  var COR_FUNDO = '#ffbf00';
  var COR_TEXTO = '#000000';

  // Remover cupom PIX do carrinho se existir (para nao afetar checkout normal)
  function removerCupomCarrinho() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).catch(function() {});
  }

  // Remover cupom ao carregar a pagina do carrinho
  removerCupomCarrinho();

  function criarBotaoPix() {
    document.querySelectorAll('#link-pagar-pix, #btn-pagar-pix').forEach(function(el) { el.remove(); });

    var btnOrcamento = document.querySelector('.btn-orcamento[data-orcamento="carrinho"]');
    if (!btnOrcamento) return;

    var formPai = btnOrcamento.closest('form.cart__recap');
    if (formPai) return;

    var link = document.createElement('a');
    link.id = 'link-pagar-pix';
    // Desconto aplicado apenas via URL — nao persiste no carrinho
    link.href = '/checkout?discount=' + COUPON;
    link.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg> Pagar com PIX <span style="background:rgba(0,0,0,0.12);border-radius:4px;padding:2px 7px;font-size:12px;font-weight:700">5% OFF</span>';
    link.style.cssText = 'display:flex;align-items:center;justify-content:center;gap:10px;width:100%;padding:14px 12px;margin-bottom:8px;background:' + COR_FUNDO + ';border:none;border-radius:10px;color:' + COR_TEXTO + ';font-size:15px;font-weight:700;cursor:pointer;text-decoration:none;box-sizing:border-box;';

    btnOrcamento.parentNode.insertBefore(link, btnOrcamento);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', criarBotaoPix);
  } else {
    criarBotaoPix();
  }
  setTimeout(criarBotaoPix, 500);
  setTimeout(criarBotaoPix, 1500);
})();
